import LazyLoadImg from "components/LazyLoadImg";
import FollowArtist from "components/shared/FollowArtist";
import { RouteName } from "constant/routeNames";
import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

function TrackPageArtistRow({ artist }: any) {
  const loggedInUser = useSelector((state: any) => state?.user?.currentUser);
  const favorite = useSelector((state: any) => state?.user?.userFavorites);
  return (
    <div className="flex w-full items-center justify-between gap-4 rounded-2xl border border-white/10 bg-white/[0.03] p-4 backdrop-blur-sm transition-colors duration-300 hover:bg-white/[0.05]">
      {/* artist details */}
      <Link
        to={RouteName.VideoCreatorHomeRoute.replace(":slug", `@${artist?.slug}`)}
        className="flex min-w-0 flex-1 items-center gap-4"
      >
        <LazyLoadImg
          imgSrc={artist?.artwork_url}
          imgAlt={artist?.slug}
          imgHeight={"56px"}
          imgWidth={"56px"}
          classname={"rounded-full shrink-0 ring-1 ring-white/10"}
        />
        <div className="min-w-0">
          <div className="mb-1 flex items-center gap-2">
            <span className="h-3 w-[3px] shrink-0 bg-[#f30543]" />
            <span className="text-[11px] font-semibold uppercase tracking-[0.14em] text-white/50">
              Artist
            </span>
          </div>
          <p className="truncate text-[17px] font-bold text-white transition-colors hover:text-[#ff5f80]">
            {artist?.name}
          </p>
        </div>
      </Link>

      {/* buttons */}
      <div className="flex shrink-0 items-center">
        {loggedInUser && (
          <FollowArtist
            user={loggedInUser}
            artistId={artist?.id}
            favorite={favorite}
            Icon={true}
            artist={artist}
          />
        )}
      </div>
    </div>
  );
}

export default TrackPageArtistRow;
